import React, { useState } from "react";
import { Accordion, AccordionDetails } from "@mui/material";
import CollapsibleCardHeader from "../collapsible-card-header/CollapsibleCardHeader";
import "./collapsibleCard.scss";

interface ICollapsibleCardProps {
	headerTitle: string;
	className?: string;
	children: React.ReactNode;
	isExpanded?: boolean;
	onToggle?: (expanded: boolean) => void;
}

const CollapsibleCard: React.FC<ICollapsibleCardProps> = ({
	headerTitle,
	children,
	className,
	isExpanded: externalIsExpanded,
	onToggle,
}) => {
	const [internalIsExpanded, setInternalIsExpanded] = useState<boolean>(true);

	const isExpanded = externalIsExpanded !== undefined ? externalIsExpanded : internalIsExpanded;

	const handleToggle = () => {
		const newExpanded = !isExpanded;
		if (onToggle) {
			onToggle(newExpanded);
		} else {
			setInternalIsExpanded(newExpanded);
		}
	};

	return (
		<Accordion className={`collapsibleCard ${className || ""}`} expanded={isExpanded} disableGutters>
			{/* Header Section */}
			<CollapsibleCardHeader isExpanded={isExpanded} title={headerTitle} handleToggle={handleToggle} />
			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	);
};

export default CollapsibleCard;
